import React from "react";
import CloneRepo from "../CodeOverview/CloneRepo.jsx";

function DataGeneration() {


  return (
    <>
      <CloneRepo />
    </>
  );
}

export default DataGeneration;